/**
 * ImToIM JavaScript SDK
 * Decentralized Instant Messaging SDK for Web
 */

import { ImToIMClient } from './core/client.js';
import { IdentityManager } from './identity/manager.js';
import { MessageService } from './messages/service.js';
import { NetworkManager } from './network/manager.js';
import { CryptoUtils } from './crypto/utils.js';

// Export individual modules
export { ImToIMClient, IdentityManager, MessageService, NetworkManager, CryptoUtils };

// Default export
export default ImToIMClient;

// Also expose as ImToIM for browser global
if (typeof window !== 'undefined') {
  window.ImToIM = ImToIMClient;
}
